/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './error-dialog.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@ngx-translate/core/src/translate.pipe';
import * as i3 from '@ngx-translate/core/src/translate.service';
import * as i4 from '../../../../../app/profile/edition/dialog/error-dialog.component';
import * as i5 from '../../../../../$$_gendir/node_modules/@angular/material/button/typings/index.ngfactory';
import * as i6 from '@angular/material/core';
import * as i7 from '@angular/material/button';
import * as i8 from '@angular/cdk/platform';
import * as i9 from '@angular/cdk/a11y';
import * as i10 from '@angular/material/dialog';
const styles_ErrorDialogComponent:any[] = [i0.styles];
export const RenderType_ErrorDialogComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ErrorDialogComponent,data:{}});
export function View_ErrorDialogComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),20,'div',[['class',
      'deconnection-dialog']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),2,'h2',([] as any[]),(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['',''])),i1.ɵpid(131072,
      i2.TranslatePipe,[i3.TranslateService,i1.ChangeDetectorRef]),(_l()(),i1.ɵted((null as any),
      ['\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
      2,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['',''])),i1.ɵpid(131072,i2.TranslatePipe,
      [i3.TranslateService,i1.ChangeDetectorRef]),(_l()(),i1.ɵted((null as any),['\n  '])),
      (_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          6,'button',[['class','mat-button mat-raised-button'],['color','primary'],
              ['mat-button',''],['mat-raised-button',''],['type','reset']],[[8,'disabled',
              0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i4.ErrorDialogComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.dialogRef.close((null as any))) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i5.View_MatButton_0,i5.RenderType_MatButton)),i1.ɵdid(16384,(null as any),
          0,i6.MatPrefixRejector,([] as any[]),(null as any),(null as any)),i1.ɵdid(180224,
          (null as any),0,i7.MatButton,[i1.Renderer2,i1.ElementRef,i8.Platform,i9.FocusMonitor],
          {color:[0,'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i7.MatButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(16384,(null as any),0,
          i7.MatRaisedButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted(0,['\n    ','\n  '])),i1.ɵpid(131072,i2.TranslatePipe,[i3.TranslateService,
          i1.ChangeDetectorRef]),(_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    const currVal_3:any = 'primary';
    _ck(_v,15,0,currVal_3);
  },(_ck,_v) => {
    var _co:i4.ErrorDialogComponent = _v.component;
    const currVal_0:any = i1.ɵunv(_v,3,0,i1.ɵnov(_v,4).transform(_co.data.messageType));
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = i1.ɵunv(_v,9,0,i1.ɵnov(_v,10).transform(_co.data.message));
    _ck(_v,9,0,currVal_1);
    const currVal_2:any = (i1.ɵnov(_v,15).disabled || (null as any));
    _ck(_v,13,0,currVal_2);
    const currVal_4:any = i1.ɵunv(_v,18,0,i1.ɵnov(_v,19).transform(_co.data.button));
    _ck(_v,18,0,currVal_4);
  });
}
export function View_ErrorDialogComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-error-dialog',
      ([] as any[]),(null as any),(null as any),(null as any),View_ErrorDialogComponent_0,
      RenderType_ErrorDialogComponent)),i1.ɵdid(49152,(null as any),0,i4.ErrorDialogComponent,
      [i10.MatDialogRef,i10.MAT_DIALOG_DATA],(null as any),(null as any))],(null as any),
      (null as any));
}
export const ErrorDialogComponentNgFactory:i1.ComponentFactory<i4.ErrorDialogComponent> = i1.ɵccf('app-error-dialog',
    i4.ErrorDialogComponent,View_ErrorDialogComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9jaHJvbm9jYXNoVjMvcGFwL3dlYmFwcC1jbGsvc3JjL2FwcC9wcm9maWxlL2VkaXRpb24vZGlhbG9nL2Vycm9yLWRpYWxvZy5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL2Nocm9ub2Nhc2hWMy9wYXAvd2ViYXBwLWNsay9zcmMvYXBwL3Byb2ZpbGUvZWRpdGlvbi9kaWFsb2cvZXJyb3ItZGlhbG9nLmNvbXBvbmVudC50cyIsIm5nOi8vL3Zhci9jaHJvbm9jYXNoVjMvcGFwL3dlYmFwcC1jbGsvc3JjL2FwcC9wcm9maWxlL2VkaXRpb24vZGlhbG9nL2Vycm9yLWRpYWxvZy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci9jaHJvbm9jYXNoVjMvcGFwL3dlYmFwcC1jbGsvc3JjL2FwcC9wcm9maWxlL2VkaXRpb24vZGlhbG9nL2Vycm9yLWRpYWxvZy5jb21wb25lbnQudHMuRXJyb3JEaWFsb2dDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwiZGVjb25uZWN0aW9uLWRpYWxvZ1wiPlxuICA8aDI+e3tkYXRhLm1lc3NhZ2VUeXBlIHwgdHJhbnNsYXRlfX08L2gyPlxuICA8ZGl2PlxuICAgIDxwPnt7ZGF0YS5tZXNzYWdlIHwgdHJhbnNsYXRlfX08L3A+XG4gIDwvZGl2PlxuICA8YnV0dG9uIG1hdC1idXR0b24gbWF0LXJhaXNlZC1idXR0b24gY29sb3I9XCJwcmltYXJ5XCIgdHlwZT1cInJlc2V0XCIgKGNsaWNrKT1cImRpYWxvZ1JlZi5jbG9zZShudWxsKVwiPlxuICAgIHt7IGRhdGEuYnV0dG9uIHwgdHJhbnNsYXRlIH19XG4gIDwvYnV0dG9uPlxuPC9kaXY+XG4iLCI8YXBwLWVycm9yLWRpYWxvZz48L2FwcC1lcnJvci1kaWFsb2c+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtNQUFBLGdCQUFpQyx5Q0FDL0I7TUFBQTtNQUFBLDhCQUFJO3VCQUFBLDRDQUFxQztNQUFBLFdBQ3pDO01BQUEsd0VBQUs7YUFBQSw0QkFDSDtNQUFBO01BQUEsZ0JBQUc7TUFBQSw0Q0FBZ0M7TUFDL0IseUNBQ047VUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1lBQWtFO2NBQUE7Y0FBQTtZQUFBO1lBQWxFO1VBQUEsdURBQUE7VUFBQSx5RUFBQTtVQUFBO1VBQUEsMENBQUE7VUFBQSxrREFBQTt5Q0FBQTtNQUFrRzs4QkFBQSxHQUV6Rix1Q0FDTDtVQUFBO0lBSGlDO0lBQXJDLFlBQXFDLFNBQXJDOzs7SUFKSTtJQUFBO0lBRUM7SUFBQTtJQUVMO0lBQUEsWUFBQSxTQUFBO0lBQWtHO0lBQUE7Ozs7b0JDTHBHO01BQUE7cUNBQUEsVUFBQTtNQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/profile/edition/dialog/error-dialog.component.ngfactory.ts